import { createEducationApi } from '@platform/billing';
import { apiClient } from '@/shared/api/client';

/**
 * 교육 호출부. 계약(엔드포인트·DTO)의 SSOT 는 `@platform/billing` 이다 —
 * 여기서 경로를 다시 적지 않는다.
 */
export const educationApi = createEducationApi(apiClient);
